'use client';

import { Filter } from '@/lib/types/filters';
import React, { ReactNode, FunctionComponent } from 'react';
import styles from './checkbox.module.scss';

interface CheckBoxType {
  label: ReactNode;
  data: Filter;
  id?: string;
  onCheck: (data: Filter, checked: boolean) => void;
  isChecked: (value: string, parameter: string) => boolean;
  required?: boolean;
  name?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  disabled?: boolean; // NEW
}

const CheckBox: FunctionComponent<CheckBoxType> = ({
  label,
  data,
  id,
  onCheck,
  isChecked,
  required,
  name,
  inputRef,
  onBlur,
  disabled = false, // NEW
}) => {
  const changeCheck = () => {
    if (disabled) return; // Prevent toggling if disabled
    const newCheckedState = !isChecked(data.value, data.parameter);
    onCheck(data, newCheckedState);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
      event.preventDefault();
      changeCheck();
    }
  };

  return (
    <label
      className={`${styles.checkbox} ${disabled ? styles.disabled : ''}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={isChecked(data.value, data.parameter)}
        onChange={changeCheck}
        onBlur={onBlur}
        ref={inputRef}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        className={styles.nativeCheckbox}
        disabled={disabled}
        aria-label={typeof label === 'string' ? label : undefined}
      />
      <span className={styles.proxyInput} aria-hidden="true"></span>
      <span className={styles.proxyLabel}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </span>
    </label>
  );
};

export default CheckBox;
